/*eslint-disable prefer-const */
/*eslint-disable no-unused-vars */
/*eslint-disable eqeqeq */
/*eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AdminUserDetails from '../../api/AdminUserDetails';
import APIEndpoints from '../../api/APIEndpoints';
import CookiesService from '../../shared/CookiesService';
import HttpErrorHandler from '../../errorhandling/HttpErrorHandler';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../errorhandling/HttpErrorCodes';
import BreadcrumbModal from './BreadcrumbModal';
import './BreadcrumbModal.scss';

import RetryAPI from '../../api/RetryAPI';
import BLOBList from '../../api/BLOBList';
import EmployerList from '../../api/EmployerList';
import LocationList from '../../api/LocationList';
import {
  setBreadCrumb,
  resetBreadCrumb,
  disableBreadCrumb,
} from '../../../redux/admin/breadCrumbSlice';

import { EditIcon, ArrowIcon } from 'src/Admin/img/Admin/BreadCrumbIcons';
import { axiosInstance } from '../../../api/axios';

const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

const BreadCrumbs = ({ isVisible }) => {
  const dispatch = useDispatch();
  const locationRoute = useLocation();
  const { blockOfBusiness, location, employer } = useSelector(
    (state) => state.breadCrumb,
  );
  const kkk = useSelector((state) => state.breadCrumb);
  console.log(
    'blockOfBusiness, location, employer',
    blockOfBusiness,
    location,
    employer,
  );
  console.log('blockOfBusiness, location, employer', kkk);
  //Breadcrumbs
  const [showBlobBreadcrumb, setShowBlobBreadcrumb] = useState(false);
  const [showEmpBreadcrumb, setShowEmpBreadcrumb] = useState(false);
  const [showLocBreadcrumb, setShowLocBreadcrumb] = useState(false);

  //Breadcrumb values
  const [showEditOfBobBreadcrumb, setshowEditOfBobBreadcrumb] = useState(false);
  const [showEditOfEmployerBreadcrumb, setshowEditOfEmployerBreadcrumb] =
    useState(false);
  const [showEditOfLocationBreadcrumb, setshowEditOfLocationBreadcrumb] =
    useState(false);

  //Select field functionality
  const [data, setData] = useState();
  const [blobData, setBlobData] = useState();
  const [empData, setEmpData] = useState();
  const [locData, setLocData] = useState();
  const [searchValue, setSearchValue] = useState('');
  const [optionsValue, setOptionsValue] = useState({ value: '' });
  const [options, setOptions] = useState([]);
  const [focused, setFocused] = useState(false);
  const [allOptions, setAllOptions] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedType, setSelectedType] = useState();

  let SearchList;
  let SearchValue;
  let optionsArray = [];

  const handleClose = () => {
    setShow(false);
    setAllOptions(false);
    setOptionsValue({ value: '' });
    setLocData(null);
  };

  const resetEmployerBreadCrumb = () => {
    dispatch(resetBreadCrumb({ breadCrumbType: 'employer' }));
  };
  const resetLocationreadCrumb = () => {
    dispatch(resetBreadCrumb({ breadCrumbType: 'location' }));
  };

  const handleApply = () => {
    if (optionsValue.value === '' && !allOptions) {
      handleClose();
      return;
    }
    if (selectedType === 'blockOfBusiness') {
      if (allOptions) {
        //BreadcrumbsAPI.setBlobBreadcrumb({ key: "all", value: "All block of business" })
        //setBlobBreadcrumb({ key: "all", value: "All block of business" })
        dispatch(resetBreadCrumb({ breadCrumbType: 'blockOfBusiness' }));
      } else {
        //BreadcrumbsAPI.setBlobBreadcrumb(optionsValue)
        //setBlobBreadcrumb(optionsValue)
        dispatch(
          setBreadCrumb({
            breadCrumbType: 'blockOfBusiness',
            breadCrumbValue: optionsValue,
          }),
        );
      }
      if (!employer.disabled) resetEmployerBreadCrumb();
      if (!location.disabled) resetLocationreadCrumb();
      //BreadcrumbsAPI.setEmployerBreadcrumb({ key: "all", value: "All Employers" })
      //setEmpBreadcrumb({ key: "all", value: "All Employers" })
      //BreadcrumbsAPI.setLocationBreadcrumb({ key: "all", value: "All Locations" })
      //setLocBreadcrumb({ key: "all", value: "All Locations" })
    }
    if (selectedType === 'employer') {
      if (allOptions) {
        //BreadcrumbsAPI.setEmployerBreadcrumb({ key: "all", value: "All Employers" })
        //setEmpBreadcrumb({ key: "all", value: "All Employers" })
        dispatch(resetBreadCrumb({ breadCrumbType: 'employer' }));
      } else {
        //let blobEmpMap = createEmpBlobDict()
        //let blobValue = blobEmpMap.get(optionsValue.key)
        //if (!blobValue) {
        //blobValue = { key: "all", value: "All block of business" }
        //}
        //BreadcrumbsAPI.setEmployerBreadcrumb(optionsValue)
        //setEmpBreadcrumb(optionsValue)
        //BreadcrumbsAPI.setBlobBreadcrumb(blobValue)
        //setBlobBreadcrumb(blobValue)
        dispatch(
          setBreadCrumb({
            breadCrumbType: 'employer',
            breadCrumbValue: optionsValue,
          }),
        );
      }
      if (!location.disabled) resetLocationreadCrumb();
      //BreadcrumbsAPI.setLocationBreadcrumb({ key: "all", value: "All Locations" })
      //setLocBreadcrumb({ key: "all", value: "All Locations" })
    }
    if (selectedType === 'location') {
      if (allOptions) {
        //BreadcrumbsAPI.setLocationBreadcrumb({ key: "all", value: "All Locations" })
        //setLocBreadcrumb({ key: "all", value: "All Locations" })
        dispatch(resetBreadCrumb({ breadCrumbType: 'location' }));
      } else {
        //BreadcrumbsAPI.setLocationBreadcrumb(optionsValue)
        //setLocBreadcrumb(optionsValue)
        //dispatch(setLocationBreadCrumb(optionsValue));
        dispatch(
          setBreadCrumb({
            breadCrumbType: 'location',
            breadCrumbValue: optionsValue,
          }),
        );
      }
    }
    handleClose();
  };

  const handleAllOptions = () => {
    if (!allOptions) {
      setOptionsValue({ value: '' });
    }
    setAllOptions(!allOptions);
  };

  const handleShow = (type) => {
    setShow(true);
    setOptions([]);
    setSelectedType(type);
  };

  const handleFocus = () => {
    commonFilterData();
    setOptions(optionsArray);
    setFocused(true);
  };

  const handleSearch = (event) => {
    SearchList = event;
    setSearchValue(event);
    commonFilterData();
    setOptions(optionsArray);
  };

  const handleBlur = () => {
    setSearchValue('');
    setFocused(false);
  };

  const handleSelect = (event) => {
    setSearchValue('');
    setAllOptions(false);
    const item = options.find((opt) => opt.value === event);
    setOptionsValue(item);
  };

  const setBlobOptions = (MappedEntities) => {
    SearchValue = MappedEntities;
    if (SearchValue && SearchList && SearchList?.length > 0) {
      SearchValue = SearchValue?.filter((ele) =>
        ele.BlockOfBusinessName.toLowerCase().startsWith(
          SearchList.toLowerCase(),
        ),
      );
    }

    optionsArray = [];
    SearchValue = SearchValue?.map((key) => {
      if (key.BlockOfBusinessName) {
        optionsArray.push({
          key: key.BlkOfBusOid,
          value: key.BlockOfBusinessName,
        });
      }
    });
    if (optionsArray && optionsArray?.length === 0) {
      blobCommonFilterData();
    }
  };

  const setEmpOptions = (MappedEntities) => {
    SearchValue = MappedEntities;
    if (data?.Response?.User?.UserType === 'Client') {
      let arr = [];
      for (let i = 0; i < MappedEntities.length; i++) {
        arr = arr.concat(MappedEntities[i].Client);
      }
      SearchValue = arr;
    } else {
      if (blockOfBusiness.key === 'all') {
        let arr = [];
        for (let i = 0; i < MappedEntities?.length; i++) {
          for (let k = 0; k < MappedEntities[i].Client?.length; k++) {
            arr = arr.concat(MappedEntities[i].Client[k]);
          }
        }
        SearchValue = arr;
      } else {
        SearchValue = SearchValue?.filter(
          (ele) => ele.BlockOfBusinessName === blockOfBusiness.value,
        );
        SearchValue = SearchValue[0]?.Client;
      }
    }

    if (SearchValue && SearchList && SearchList?.length > 0) {
      SearchValue = SearchValue?.filter((ele) =>
        ele.ClientName.toLowerCase().startsWith(SearchList.toLowerCase()),
      );
    }

    optionsArray = [];
    SearchValue = SearchValue?.map((key) => {
      if (key.ClientName) {
        optionsArray.push({
          key: key.ClientOid,
          value: key.ClientName,
          clientID: key.ClientID,
          clientCode: key.Description,
        });
      }
    });
    if (optionsArray && optionsArray?.length === 0) {
      employerCommonFilterData();
    }
  };

  const setLocOptions = (MappedEntities) => {
    SearchValue = MappedEntities;
    if (data.Response.User.UserType === 'Client') {
      let arr = [];
      for (let i = 0; i < MappedEntities?.length; i++) {
        arr = arr.concat(MappedEntities[i].Client[0]);
      }
      SearchValue = arr;
    } else {
      SearchValue = SearchValue?.filter(
        (ele) =>
          ele.BlockOfBusinessName === blockOfBusiness.value ||
          blockOfBusiness.key === 'all',
      )?.Client;
    }
    SearchValue = SearchValue?.filter(
      (ele) => ele.ClientName === employer.value || employer.key === 'all',
    );

    let arr = [];
    for (let i = 0; i < SearchValue?.length; i++) {
      arr = arr.concat(SearchValue[0].Location);
    }
    SearchValue = arr;

    if (SearchValue && SearchList && SearchList?.length > 0) {
      SearchValue = SearchValue?.filter((ele) =>
        ele.LocationName.toLowerCase().startsWith(SearchList.toLowerCase()),
      );
    }

    optionsArray = [];
    SearchValue = SearchValue?.map((key) => {
      if (key.LocationName) {
        optionsArray.push({
          key: key.LocationOid,
          value: key.LocationName,
        });
      }
    });

    if (optionsArray && optionsArray?.length === 0) {
      getLocationList();
    }
  };

  const blobCommonFilterData = () => {
    SearchValue = BLOBList.getBLOBListResp();
    SearchValue = SearchValue?.Response.BlockOfBusiness;

    if (SearchList && SearchList?.length > 0) {
      SearchValue = SearchValue?.filter((ele) =>
        ele.BlkOfBusName.toLowerCase().startsWith(SearchList.toLowerCase()),
      );
    }

    optionsArray = [];
    return (
      SearchValue &&
      SearchValue?.map((key) => {
        if (key.BlkOfBusName) {
          optionsArray.push({
            key: key.oid,
            value: key.BlkOfBusName,
          });
        }
      })
    );
  };

  const employerCommonFilterData = () => {
    SearchValue = EmployerList.getClientListResp();
    if (blockOfBusiness.key !== 'all') {
      SearchValue = SearchValue?.Response.Client.filter((item) => {
        return item.BlkOfBusOid == blockOfBusiness.key;
      });
    } else {
      SearchValue = SearchValue?.Response.Client.filter((item) => {
        return true;
      });
    }

    if (SearchList && SearchValue?.length > 0) {
      SearchValue = SearchValue?.filter((ele) =>
        ele.ClientName.toLowerCase().startsWith(SearchList.toLowerCase()),
      );
    }

    optionsArray = [];
    return (
      SearchValue &&
      SearchValue?.map((key) => {
        if (key.ClientName) {
          optionsArray.push({
            key: key.oid,
            value: key.ClientName,
            blockOfBusinessKey: key.BlkOfBusOid,
            blockOfBusinessName: key.BlkOfBusName,
            clientID: key.ClientId,
            clientCode: key.Description,
          });
        }
      })
    );
  };

  const locationCommonFilterData = (LocationListData = null) => {
    SearchValue = locData?.Response.Location.filter((item) => {
      return item.ClientOid === employer.key;
    });

    if (!SearchValue) {
      SearchValue = LocationListData?.Response.Location.filter((item) => {
        return item.ClientOid === employer.key;
      });
    }

    if (SearchList && SearchValue?.length > 0) {
      SearchValue = SearchValue.filter((ele) =>
        ele.LocationName.toLowerCase().startsWith(SearchList.toLowerCase()),
      );
    }
    optionsArray = [];
    return (
      SearchValue &&
      SearchValue?.map((key) => {
        if (key.LocationName) {
          optionsArray.push({
            key: key.oid,
            value: key.LocationName,
          });
        }
      })
    );
  };

  const commonFilterData = () => {
    const MappedEntities = data?.Response?.User?.MappedEnties || [];

    if (selectedType === 'blockOfBusiness') {
      return setBlobOptions(MappedEntities);
    }
    if (selectedType === 'employer') {
      return setEmpOptions(MappedEntities);
    }
    if (selectedType === 'location') {
      return setLocOptions(MappedEntities);
    }
  };

  const breadcrumbsToDisplay = (responseData) => {
    const userData = data || responseData;
    if (userData.Response.User.UserType == 'Client') {
      setShowBlobBreadcrumb(false);
      setShowEmpBreadcrumb(true);
      setShowLocBreadcrumb(true);
    } else {
      setShowBlobBreadcrumb(true);
      setShowEmpBreadcrumb(true);
      setShowLocBreadcrumb(true);
    }
  };

  const createEmpBlobDict = () => {
    const map = new Map();
    const clientList = empData?.Response?.Client || [];
    for (let i = 0; i < clientList?.length; i++) {
      map.set(clientList[i].oid, {
        key: clientList[i].BlkOfBusOid,
        value: clientList[i].BlkOfBusName,
      });
    }
    return map;
  };

  const getLocationList = async () => {
    //let bearerToken = '', refreshToken = '', LocationListAPI = '';
    //let LocationListData = null;
    //let LocationListResponse = null;
    //bearerToken = CookiesService.get('loginToken');
    //LocationListAPI = axios.create({
    //headers: {
    //Authorization: bearerToken,
    //'X-ClientID': HttpHeader.getCNAME(),
    //'Accept': 'application/json',
    //},
    //});

    let clientId = '';
    for (let i = 0; i < empData?.Response.Client?.length; i++) {
      if (empData?.Response.Client[i].oid === employer.key) {
        clientId = empData?.Response.Client[i].oid;
      }
    }
    if (clientId !== '') {
      RetryAPI.setResponseReceived(false);
      RetryAPI.resetRetryCount();
      while (RetryAPI.performRetry()) {
        try {
          const LocationListResponse = await axiosInstance.get(
            cacheBuster(
              APIEndpoints.getLocationListResources() + 'clientoid/' + clientId,
            ),
          );
          const LocationListData = LocationListResponse.data;
          if (
            LocationListResponse.status ==
            HttpSuccessCodes.HTTP_SUCCESS_CODE_200
          ) {
            LocationList.setLocationListResp(LocationListData);
            RetryAPI.resetRetryCount();
            RetryAPI.setResponseReceived(true);
            setLocData(LocationListData);
            locationCommonFilterData(LocationListData);
            setOptions(optionsArray);
          } else {
            RetryAPI.incrementRetryCount();
            RetryAPI.setResponseReceived(false);
            RetryAPI.setErrorCode(LocationListResponse.status);
          }

          if (RetryAPI.getResponseReceived()) break;
        } catch (error) {
          //var errorMessage = '';
          //var requestAborted = '';
          if (error) {
            //errorMessage = error.toString();
            //requestAborted = errorMessage.match(/aborted/i);
            RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
          }
          if (error.response) {
            RetryAPI.setErrorCode(error.response.status);
          }
          RetryAPI.incrementRetryCount();
          RetryAPI.setResponseReceived(false);
          setLocData({ Response: { Location: [] } });
        }
      }

      if (RetryAPI.retryFailed()) {
        const errorCode = RetryAPI.getErrorCode();
        HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');
        //Handle Exception
        HttpErrorHandler.ProcessedException(
          errorCode,
          'We are unable to render your Location List now.',
        );
        return;
      }
    }
  };

  useEffect(() => {
    setshowEditOfBobBreadcrumb(false);
    setshowEditOfEmployerBreadcrumb(false);
    setshowEditOfLocationBreadcrumb(false);
    const getUserDetails = async () => {
      const emailID = localStorage.getItem('email-id');
      const response = AdminUserDetails.getUserDetailResp();
      if (response) {
        setData(response);
        breadcrumbsToDisplay(response);
      } else {
        try {
          const response = await axiosInstance.get(
            cacheBuster(APIEndpoints.getUserListDetailsResources() + emailID),
          );

          console.log('getUserDetailsOnBoarding response', response);
          if (
            response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
            response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
          ) {
            const responseData = response?.data;
            const userData = responseData?.Response?.User;

            AdminUserDetails.setUserDetailResp(responseData);
            setData(responseData);
            breadcrumbsToDisplay(responseData);
            console.log('userData', userData);

            const bobVal = userData.MappedEnties[0]?.BlockOfBusinessName;
            const employerVal = userData.MappedEnties[0]?.Client[0]?.ClientName;
            const locationVal =
              userData.MappedEnties[0]?.Client[0]?.Location[0]?.LocationName;

            if (
              userData?.MappedEnties != null &&
              userData?.UserType == 'Client' &&
              userData?.MappedEnties?.length <= 1
            ) {
              dispatch(
                setBreadCrumb({
                  breadCrumbType: 'employer',
                  breadCrumbValue: { value: employerVal },
                }),
              );
            } else {
              dispatch(
                setBreadCrumb({
                  breadCrumbType: 'employer',
                  breadCrumbValue: { value: ' All Employers' },
                }),
              );
            }

            if (
              userData?.MappedEnties != null &&
              userData?.UserType == 'Insurer' &&
              userData?.MappedEnties?.length == 1
            ) {
              if (
                userData.MappedEnties[0].Client.length == 1 &&
                bobVal != 'All Block of Business'
              ) {
                console.log('only one associated');
                setshowEditOfBobBreadcrumb(true);
                setshowEditOfEmployerBreadcrumb(true);
                setshowEditOfLocationBreadcrumb(false);
                dispatch(
                  setBreadCrumb({
                    breadCrumbType: 'blockOfBusiness',
                    breadCrumbValue: {
                      key: userData.MappedEnties[0]?.BlkOfBusOid,
                      value: bobVal,
                    },
                  }),
                );
                dispatch(
                  setBreadCrumb({
                    breadCrumbType: 'employer',
                    breadCrumbValue: {
                      key: userData.MappedEnties[0]?.Client[0]?.ClientOid,
                      value: employerVal,
                    },
                  }),
                );

                if (userData.MappedEnties[0]?.Client[0]?.Location.length == 1) {
                  dispatch(
                    setBreadCrumb({
                      breadCrumbType: 'location',
                      breadCrumbValue: locationVal,
                    }),
                  );
                } else {
                  dispatch(
                    setBreadCrumb({
                      breadCrumbType: 'location',
                      breadCrumbValue: { value: 'All Locations' },
                    }),
                  );
                }
              } else {
                console.log('multiple associated');
                setshowEditOfBobBreadcrumb(false);
                setshowEditOfEmployerBreadcrumb(true);
                setshowEditOfLocationBreadcrumb(false);
                dispatch(
                  setBreadCrumb({
                    breadCrumbType: 'blockOfBusiness',
                    breadCrumbValue: { value: bobVal },
                  }),
                );
                dispatch(
                  setBreadCrumb({
                    breadCrumbType: 'employer',
                    breadCrumbValue: { value: 'All Employers' },
                  }),
                );
                dispatch(
                  setBreadCrumb({
                    breadCrumbType: 'location',
                    breadCrumbValue: { value: 'All Locations' },
                  }),
                );
              }
            } else {
              console.log('In else block ---------');
              dispatch(
                setBreadCrumb({
                  breadCrumbType: 'blockOfBusiness',
                  breadCrumbValue: { value: 'All Block of Business' },
                }),
              );
              dispatch(
                setBreadCrumb({
                  breadCrumbType: 'employer',
                  breadCrumbValue: { value: ' All Employers' },
                }),
              );
              dispatch(
                setBreadCrumb({
                  breadCrumbType: 'location',
                  breadCrumbValue: { value: 'All Locations' },
                }),
              );
              setshowEditOfBobBreadcrumb(false);
              setshowEditOfEmployerBreadcrumb(false);
              setshowEditOfLocationBreadcrumb(false);
            }
          } else {
            HttpErrorHandler.DisplayServerErrorMessage(response.status, '');
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
    getUserDetails();
  }, []);

  useEffect(() => {
    setshowEditOfBobBreadcrumb(false);
    setshowEditOfEmployerBreadcrumb(false);
    setshowEditOfLocationBreadcrumb(false);
    const getBlobList = async () => {
      //let bearerToken = '', refreshToken = '', BLOBListAPI = '';
      //let BLOBListData = '';
      //let BLOBListResponse, BLOBListDataResp;
      //bearerToken = CookiesService.get('loginToken');
      //BLOBListAPI = axios.create({
      //headers: {
      //Authorization: bearerToken,
      //'X-ClientID': HttpHeader.getCNAME(),
      //Accept: 'application/json',
      //},
      //});
      if (blobData) {
        blobCommonFilterData();
        setOptions(optionsArray);
      }
      if (!blobData) {
        RetryAPI.setResponseReceived(false);
        RetryAPI.resetRetryCount();
        while (RetryAPI.performRetry()) {
          try {
            const BLOBListResponse = await axiosInstance.get(
              cacheBuster(
                APIEndpoints.getBLOBListResources() + 'pagesize/5000',
              ),
            );
            //BLOBListResponse = EncrptedResp;
            //refreshToken = BLOBListResponse.config.headers.Authorization;
            //HttpHeader.refreshBearerToken(refreshToken);
            const BLOBListDataResp = BLOBListResponse.data;
            if (
              BLOBListResponse.status == HttpSuccessCodes.HTTP_SUCCESS_CODE_200
            ) {
              BLOBList.setBLOBListResp(BLOBListDataResp);
              RetryAPI.resetRetryCount();
              RetryAPI.setResponseReceived(true);
              setBlobData(BLOBListDataResp);
            } else {
              RetryAPI.incrementRetryCount();
              RetryAPI.setResponseReceived(false);
              RetryAPI.setErrorCode(BLOBListResponse.status);
            }

            if (RetryAPI.getResponseReceived()) break;
          } catch (error) {
            //var errorMessage = '';
            const requestAborted = '';
            if (error) {
              //errorMessage = error.toString();
              //requestAborted = errorMessage.match(/aborted/i);
              RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
            }
            if (error.response) {
              RetryAPI.setErrorCode(error.response.status);
            }
            RetryAPI.incrementRetryCount();
            RetryAPI.setResponseReceived(false);
          }
        }

        if (RetryAPI.retryFailed()) {
          const errorCode = RetryAPI.getErrorCode();
          HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');
          //Handle Exception
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to render your BLOB List now.',
          );
          return;
        }
      }
    };

    const getEmployerList = async () => {
      let bearerToken = '',
        refreshToken = '',
        EmployerListAPI = '';
      const EmployerListData = '';
      let EmployerListResponse, EmployerListDataResp;
      bearerToken = CookiesService.get('loginToken');
      //EmployerListAPI = axios.create({
      //headers: {
      //Authorization: bearerToken,
      //'X-ClientID': HttpHeader.getCNAME(),
      //'Accept': 'application/json',
      //},
      //});
      if (empData) {
        employerCommonFilterData();
        setOptions(optionsArray);
      }
      if (!empData) {
        RetryAPI.setResponseReceived(false);
        RetryAPI.resetRetryCount();
        while (RetryAPI.performRetry()) {
          try {
            const EmployerListResponse = await axiosInstance.get(
              cacheBuster(
                APIEndpoints.getEmployerListResources() + 'pagesize/5000',
              ),
            );

            //EmployerListResponse = EncrptedResp;

            //refreshToken = EmployerListResponse.config.headers.Authorization;
            //HttpHeader.refreshBearerToken(refreshToken);

            EmployerListDataResp = EmployerListResponse.data;

            if (
              EmployerListResponse.status ==
              HttpSuccessCodes.HTTP_SUCCESS_CODE_200
            ) {
              EmployerList.setClientListResp(EmployerListDataResp);
              RetryAPI.resetRetryCount();
              RetryAPI.setResponseReceived(true);
              setEmpData(EmployerListDataResp);
            } else {
              RetryAPI.incrementRetryCount();
              RetryAPI.setResponseReceived(false);
              RetryAPI.setErrorCode(EmployerListResponse.status);
            }

            if (RetryAPI.getResponseReceived()) break;
          } catch (error) {
            //var errorMessage = '';
            //var requestAborted = '';
            if (error) {
              //errorMessage = error.toString();
              //requestAborted = errorMessage.match(/aborted/i);
              RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
            }
            if (error.response) {
              RetryAPI.setErrorCode(error.response.status);
            }
            RetryAPI.incrementRetryCount();
            RetryAPI.setResponseReceived(false);
          }
        }

        if (RetryAPI.retryFailed()) {
          const errorCode = RetryAPI.getErrorCode();
          HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');
          //Handle Exception
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to render your Employer List now.',
          );
          return;
        }
      }
    };

    getBlobList();
    getEmployerList();
  }, []);

  useEffect(() => {
    if (
      locationRoute.pathname === '/admin/enrollment-rules' &&
      employer.key === 'all'
    ) {
      const value = {
        key: empData?.Response?.Client[0].oid,
        value: empData?.Response?.Client[0].ClientName,
        blockOfBusinessKey: empData?.Response?.Client[0].BlkOfBusOid,
        blockOfBusinessName: empData?.Response?.Client[0].BlkOfBusName,
        clientId: empData?.Response?.Client[0].ClientId,
        clientCode: empData?.Response?.Client[0].Description,
      };
      dispatch(
        setBreadCrumb({
          breadCrumbType: 'employer',
          breadCrumbValue: value,
        }),
      );
    }
  }, [locationRoute.pathname]);

  return (
    <div className={isVisible ? 'd-block' : 'd-none'}>
      <Breadcrumb>
        {showBlobBreadcrumb && blockOfBusiness.visible && (
          <React.Fragment>
            <Breadcrumb.Item
              href="#"
              onClick={
                !blockOfBusiness.disabled && !showEditOfBobBreadcrumb
                  ? () => handleShow('blockOfBusiness')
                  : () => {}
              }
              className={
                blockOfBusiness.disabled ? 'disabled-breadcrumb-item' : ''
              }
            >
              {blockOfBusiness.value}
              {!blockOfBusiness.disabled && !showEditOfBobBreadcrumb && (
                <span>
                  <EditIcon className="edit-breadcrumb-icon" />
                </span>
              )}
            </Breadcrumb.Item>
            {showEmpBreadcrumb && employer && employer.visible && (
              <span className="mx-2 mt-1">
                <ArrowIcon className="arrow-breadcrumb-icon" />
              </span>
            )}
          </React.Fragment>
        )}

        {showEmpBreadcrumb && employer && employer.visible && (
          <React.Fragment>
            <Breadcrumb.Item
              href="#"
              onClick={
                !employer.disabled && !showEditOfEmployerBreadcrumb
                  ? () => handleShow('employer')
                  : () => {}
              }
              className={employer.disabled ? 'disabled-breadcrumb-item' : ''}
            >
              {employer.value}
              {!employer.disabled && !showEditOfEmployerBreadcrumb && (
                <span>
                  <EditIcon className="edit-breadcrumb-icon" />
                </span>
              )}
            </Breadcrumb.Item>
            {showLocBreadcrumb && location.visible && (
              <span className="mx-2 mt-1">
                <ArrowIcon className="arrow-breadcrumb-icon" />
              </span>
            )}
          </React.Fragment>
        )}

        {showLocBreadcrumb && location.visible && (
          <Breadcrumb.Item
            href="#"
            onClick={
              !location.disabled ? () => handleShow('location') : () => {}
            }
            className={location.disabled ? 'disabled-breadcrumb-item' : ''}
          >
            {location.value}
            {!location.disabled && (
              <span>
                <EditIcon className="edit-breadcrumb-icon" />
              </span>
            )}
          </Breadcrumb.Item>
        )}
      </Breadcrumb>

      <BreadcrumbModal
        show={show}
        options={options}
        searchValue={searchValue}
        optionsValue={optionsValue}
        allOptions={allOptions}
        blobData={blobData}
        empData={empData}
        locData={locData}
        focused={focused}
        selectedType={selectedType}
        blobBreadcrumb={blockOfBusiness}
        empBreadcrumb={employer}
        onClose={handleClose}
        onFocus={handleFocus}
        onSearch={handleSearch}
        onBlur={handleBlur}
        onSelect={handleSelect}
        onAllOptions={handleAllOptions}
        onApply={handleApply}
      />
    </div>
  );
};
export default BreadCrumbs;
